import { theme } from '@dojo/framework/core/mixins/Themed';
import { w, v } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';
import { storeInject } from '@dojo/framework/stores/StoreInjector';
import Store from '@dojo/framework/stores/Store';
import { Messages, Bundle } from '@dojo/framework/i18n/i18n';

import { I18nThemed } from 'interfaces/mixins';
import { lccstore, SiteMeta } from 'lcc-state';
import { get_related } from 'cache-store';

import { svc } from '../support/svc';
import { RelatedTopic } from './related-topic';

import css from '../css/related-topics.m.css';

export interface RelatedTopicsProperties {
	topicid: string;
	bundle?: Bundle<Messages>;
}

@theme(css)
@storeInject({
	name: 'lcc-state',
	getProperties: (store: Store<SiteMeta>) => {
		const { get, path } = store;
		const dynls = get(path('dynls'));
		const bundle = dynls.get('ditabook');
		return {
			bundle
		};
	},
	paths: [['dynls']]
})
export class RelatedTopics extends I18nThemed<RelatedTopicsProperties> {
	private related: string[] | undefined;

	protected async get_related() {
		const { topicid } = this.properties;
		const language = window.hcstatic.portal_language || 'en';
		const { get, path } = lccstore;
		const version = get(path('bookversion'));

		this.related = await get_related({
			key: topicid,
			version,
			language,
			related_getter: ({ key, version, language }: { key: string; version: string; language: string }) =>
				svc.related_topics({ topicid: key, version, language })
		});
		// this.related = await svc.related_topics({ topicid, version, language });
		this.invalidate();
	}

	protected render_related(): DNode[] {
		if (this.related === undefined) {
			return [];
		}
		const { bundle } = this.properties;
		const localizedBundle = this.localizeBundle(bundle!);
		const {
			messages: { related_topics = '[ditabook] related_topics' }
		} = localizedBundle;

		const relatedItems = this.related.map((topicid) => w(RelatedTopic, { topicid, localizedBundle }));

		return [
			v('h4', { classes: [this.theme(css.heading)] }, [related_topics]),
			v('div', { classes: [this.theme(css.relatedItems)] }, relatedItems)
		];
	}

	protected render(): DNode {
		if (this.related === undefined) {
			this.get_related();
			return null;
		}

		const len_related = this.related.length;

		return v(
			'div',
			{ key: 'related-topics', xqa: 'topics related', classes: [this.theme(css.root)] },
			len_related > 0 ? this.render_related() : []
		);
	}
}
